import Vue from "vue";
import VueRouter from "vue-router";
import permissions from "./mixin/permissions.js";

function loadView(view) {
    return () => import(`./${view}.vue`);
}

// Routes
const routes = [
    {
        path: "/statistics/clients",
        name: "statistics.clients",
        component: loadView('components/Pages/Dashboard/Statistics/ClientsStatistics'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'statistics.viewAny', 'statistics.clients'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Статистика по клієнтам"
        }
    },
    {
        path: "/statistics/orders",
        name: "statistics.orders",
        component: loadView('components/Pages/Dashboard/Statistics/OrdersStatistics'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'statistics.viewAny', 'statistics.orders'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Статистика по угодам"
        }
    },
    {
        path: "/statistics/offers",
        name: "statistics.offers",
        component: loadView('components/Pages/Dashboard/Statistics/OffersStatistics'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'statistics.viewAny', 'statistics.offers'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Статистика по показам"
        }
    },
    {
        path: "/statistics/prices",
        name: "statistics.prices",
        component: loadView('components/Pages/Dashboard/Statistics/PricesStatistics'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'statistics.viewAny', 'statistics.prices'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Статистика по цінам"
        }
    },
    {
        path: "/statistics/plannings",
        name: "statistics.plannings",
        component: loadView('components/Pages/Dashboard/Statistics/PlanningStatistics'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'planning_statistics.viewAny', 'planning_statistics.view'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Статистика планьорок"
        }
    },
    {
        path: "/telegram",
        name: "telegram",
        component: loadView('components/Pages/Help/Telegram'),
        meta: {
            auth: {
                roles: ['SuperAdmin'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Telegram Set Webhook"
        }
    },
    {
        path: "/help/clients",
        name: "help",
        component: loadView('components/Pages/Help/Help'),
        meta: {
            layout: "DashboardLayout",
            title: "Часті запитання"
        }
    },
    {
        path: "/",
        name: "index",
        component: loadView('components/Pages/Index/Index'),
        meta: {
            layout: "MainLayout",
            title: "CRM"
        }
    },
    {
        path: "/login",
        name: "login",
        component: loadView('components/Pages/Auth/Login'),
        meta: {
            auth: undefined,
            layout: "MainLayout",
            title: "Логін"
        }
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: loadView('components/Pages/Dashboard/Index/Dashboard'),
        meta: {
            auth: true,
            layout: "DashboardLayout",
            title: "Головна"
        }
    },
    //profile
    {
        path: "/profile",
        name: "profile",
        component: loadView('components/Pages/Dashboard/Profile/ProfileIndex'),
        meta: {
            auth: true,
            layout: "DashboardLayout",
            title: "Профіль"
        }
    },
    //Objects
    {
        path: "/objects",
        name: "objects",
        component: loadView('components/Pages/Dashboard/Objects/ObjectsList'),
        meta: {
            auth: true,
            layout: "DashboardLayout",
            title: "Об'єкти"
        }
    },

    //Roles
    {
        path: "/roles",
        name: "roles",
        component: loadView('components/Pages/Dashboard/Roles/RolesList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'roles.viewAny'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Ролі"
        }
    },

    {
        path: "/roles/create",
        name: "roles.create",
        component: loadView('components/Pages/Dashboard/Roles/RolesCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'roles.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Ролі"
        }
    },

    {
        path: "/roles/:id",
        name: "roles.update",
        component: loadView('components/Pages/Dashboard/Roles/RolesUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'roles.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Ролі"
        }
    },
    //Users
    {
        path: "/users",
        name: "users",
        component: loadView('components/Pages/Dashboard/Users/UsersList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'users.viewAny', 'users.viewMyOnly'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Користувачі"
        }
    },

    {
        path: "/users/create",
        name: "users.create",
        component: loadView('components/Pages/Dashboard/Users/UsersCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'users.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Користувачі"
        }
    },

    {
        path: "/users/:id",
        name: "users.update",
        component: loadView('components/Pages/Dashboard/Users/UsersUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'users.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Користувачі"
        }
    },

    //Clients
    {
        path: "/clients/list",
        name: "clients",
        component: loadView('components/Pages/Dashboard/Clients/ClientsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'clients.viewAny', 'clients.viewMyOnly'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Клієнти"
        }
    },

    {
        path: "/clients/create",
        name: "clients.create",
        component: loadView('components/Pages/Dashboard/Clients/ClientsCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'clients.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Клієнти"
        }
    },

    {
        path: "/clients/orders",
        name: "clients.orders",
        component: loadView('components/Pages/Dashboard/Orders/List'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'clients.viewAny', 'clients.viewMyOnly'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Угоди клієнтів"
        }
    },

    {
        path: "/clients/:id",
        name: "clients.update",
        component: loadView('components/Pages/Dashboard/Clients/ClientsUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'clients.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Клієнти"
        }
    },

    //Reports
    {
        path: "/reports",
        name: "reports",
        component: loadView('components/Pages/Dashboard/Reports/ReportsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'reports.viewAny', 'reports.viewMyOnly'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Звіти"
        }
    },

    {
        path: "/reports/create",
        name: "reports.create",
        component: loadView('components/Pages/Dashboard/Reports/ReportsCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'reports.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Новий звіт"
        }
    },

    {
        path: "/reports/:id",
        name: "reports.update",
        component: loadView('components/Pages/Dashboard/Reports/ReportsUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'reports.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Редагування звіту"
        }
    },

    {
        path: "/reports/:id/view",
        name: "reports.view",
        component: loadView('components/Pages/Dashboard/Reports/ReportsView'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'reports.view' , 'reports.viewMyOnly'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Перегляд звіту"
        }
    },

    //Plannings
    {
        path: "/plannings",
        name: "plannings",
        component: loadView('components/Pages/Dashboard/Plannings/PlanningsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'plannings.viewAny', 'plannings.viewOwn'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Планьорки"
        }
    },

    {
        path: "/plannings/create",
        name: "plannings.create",
        component: loadView('components/Pages/Dashboard/Plannings/PlanningsCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'plannings.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Нова планьорка"
        }
    },

    {
        path: "/plannings/:id/view",
        name: "plannings.view",
        component: loadView('components/Pages/Dashboard/Plannings/PlanningsView'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'plannings.view', 'plannings.viewOwn'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Перегляд планьорки"
        }
    },

    {
        path: "/plannings/:id",
        name: "plannings.update",
        component: loadView('components/Pages/Dashboard/Plannings/PlanningsUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'plannings.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Редагування планьорки"
        }
    },

    {
        path: "/callsapp/calls",
        name: "callsapp.calls",
        component: loadView('components/Pages/Dashboard/Telephony/CallsAppCallsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'callsapp.calls.viewAny', 'callsapp.calls.viewMy'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Журнал дзвінків"
        }
    },

    {
        path: "/call-analysis/settings",
        name: "call_analysis.settings",
        component: loadView('components/Pages/Dashboard/Telephony/CallAnalysisSettings'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'call_analysis.settings.manage'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Аналіз дзвінків"
        },
        beforeEnter(to, from, next) {
            const auth = Vue.prototype.$auth;
            const user = auth && typeof auth.user === 'function' ? auth.user() : null;
            if (!user || !user.call_analysis_enabled) {
                next({ name: 'dashboard' });
                return;
            }
            next();
        },
    },

    //Education
    {
        path: "/education/courses",
        name: "education.courses",
        component: loadView('components/Pages/Dashboard/Education/Courses/CoursesList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'courses.viewAny', 'courses.view'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Курси"
        }
    },
    {
        path: "/education/courses/create",
        name: "education.courses.create",
        component: loadView('components/Pages/Dashboard/Education/Courses/CoursesCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'courses.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Новий курс"
        }
    },
    {
        path: "/education/courses/:id",
        name: "education.courses.update",
        component: loadView('components/Pages/Dashboard/Education/Courses/CoursesUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'courses.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Редагування курсу"
        }
    },
    {
        path: "/education/modules",
        name: "education.modules",
        component: loadView('components/Pages/Dashboard/Education/Modules/ModulesList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'modules.viewAny', 'modules.view'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Модулі"
        }
    },
    {
        path: "/education/modules/create",
        name: "education.modules.create",
        component: loadView('components/Pages/Dashboard/Education/Modules/ModulesCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'modules.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Новий модуль"
        }
    },
    {
        path: "/education/modules/:id",
        name: "education.modules.update",
        component: loadView('components/Pages/Dashboard/Education/Modules/ModulesUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'modules.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Редагування модуля"
        }
    },
    {
        path: "/education/modules",
        name: "education.modules",
        component: loadView('components/Pages/Dashboard/Education/Modules/ModulesPlaceholder'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'modules.viewAny', 'modules.view'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Модулі"
        }
    },
    {
        path: "/education/lessons",
        name: "education.lessons",
        component: loadView('components/Pages/Dashboard/Education/Lessons/LessonsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'lessons.viewAny', 'lessons.view'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Уроки"
        }
    },
    {
        path: "/education/lessons/create",
        name: "education.lessons.create",
        component: loadView('components/Pages/Dashboard/Education/Lessons/LessonsCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'lessons.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Новий урок"
        }
    },
    {
        path: "/education/lessons/:id",
        name: "education.lessons.update",
        component: loadView('components/Pages/Dashboard/Education/Lessons/LessonsUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'lessons.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Редагування уроку"
        }
    },
    {
        path: "/education/lessons/:id/view",
        name: "education.lessons.view",
        component: loadView('components/Pages/Dashboard/Education/Lessons/LessonsView'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'lessons.viewAny', 'lessons.view'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Перегляд уроку"
        }
    },

    //System

    //LogsRecords
    {
        path: "/system/logs",
        name: "system.logs",
        component: loadView('components/Pages/Dashboard/System/LogsRecords/LogRecordsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'logs.viewAny'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Лог помилок"
        }
    },

    {
        path: "/system/logs/:id",
        name: "system.logs.view",
        component: loadView('components/Pages/Dashboard/System/LogsRecords/LogRecordsView'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'logs.viewAny', 'logs.view'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Лог помилок"
        }
    },

    {
        path: "/site/logs",
        name: "site.logs",
        component: loadView('components/Pages/Dashboard/System/SiteLog/LogRecordsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'actions.viewAny', 'actions.view'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Лог сайту"
        }
    },

    {
        path: "/site/logs/:id",
        name: "site.logs.view",
        component: loadView('components/Pages/Dashboard/System/SiteLog/LogRecordsView'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'actions.viewAny', 'actions.view'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Лог сайту"
        }
    },

    //////////////////////////Dictionaries
    //LandPurposes
    {
        path: "/dictionaries/land-purposes",
        name: "dictionaries.land_purposes",
        component: loadView('components/Pages/Dashboard/Dictionaries/LandPurposes/LandPurposesList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'land_purpose.viewAny'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Ділянки. Цільове призначення"
        }
    },

    {
        path: "/dictionaries/land-purposes/create",
        name: "dictionaries.land_purposes.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/LandPurposes/LandPurposesCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'land_purpose.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Ділянки. Цільове призначення"
        }
    },

    {
        path: "/dictionaries/land-purposes/:id",
        name: "dictionaries.land_purposes.update",
        component: loadView('components/Pages/Dashboard/Dictionaries/LandPurposes/LandPurposesUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'land_purpose.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Ділянки. Цільове призначення"
        }
    },

    //RoomTypes
    {
        path: "/dictionaries/room-types",
        name: "dictionaries.room_types",
        component: loadView('components/Pages/Dashboard/Dictionaries/RoomTypes/RoomTypesList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'room_type.viewAny'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Тип приміщення"
        }
    },

    {
        path: "/dictionaries/room-types/create",
        name: "dictionaries.room_types.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/RoomTypes/RoomTypesCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'room_type.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Тип приміщення"
        }
    },

    {
        path: "/dictionaries/room-types/:id",
        name: "dictionaries.room_types.update",
        component: loadView('components/Pages/Dashboard/Dictionaries/RoomTypes/RoomTypesUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'room_type.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Тип приміщення"
        }
    },

    //RoomPurpose
    {
        path: "/dictionaries/room-purposes",
        name: "dictionaries.room_purposes",
        component: loadView('components/Pages/Dashboard/Dictionaries/RoomPurposes/RoomPurposesList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'room_purpose.viewAny'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Приміщення. Цільове призначення"
        }
    },

    {
        path: "/dictionaries/room-purposes/create",
        name: "dictionaries.room_purposes.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/RoomPurposes/RoomPurposesCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'room_purpose.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Приміщення. Цільове призначення"
        }
    },

    {
        path: "/dictionaries/room-purposes/:id",
        name: "dictionaries.room_purposes.update",
        component: loadView('components/Pages/Dashboard/Dictionaries/RoomPurposes/RoomPurposesUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'room_purpose.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Приміщення. Цільове призначення"
        }
    },

    //LandOwnership
    {
        path: "/dictionaries/land-ownerships",
        name: "dictionaries.land_ownerships",
        component: loadView('components/Pages/Dashboard/Dictionaries/LandOwnerships/LandOwnershipsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'land_ownership.viewAny'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Право власності на землю"
        }
    },

    {
        path: "/dictionaries/land-ownerships/create",
        name: "dictionaries.land_ownerships.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/LandOwnerships/LandOwnershipsCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'land_ownership.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Право власності на землю"
        }
    },

    {
        path: "/dictionaries/land-ownerships/:id",
        name: "dictionaries.land_ownerships.update",
        component: loadView('components/Pages/Dashboard/Dictionaries/LandOwnerships/LandOwnershipsUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'land_ownership.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Право власності на землю"
        }
    },

    //MeetingResults
    {
        path: "/dictionaries/meeting-results",
        name: "dictionaries.meeting_results",
        component: loadView('components/Pages/Dashboard/Dictionaries/MeetingResults/MeetingResultsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'meeting_result.viewAny'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Результати зустрічей"
        }
    },

    {
        path: "/dictionaries/meeting-results/create",
        name: "dictionaries.meeting_results.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/MeetingResults/MeetingResultsCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'meeting_result.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Результати зустрічей"
        }
    },

    {
        path: "/dictionaries/meeting-results/:id",
        name: "dictionaries.meeting_results.update",
        component: loadView('components/Pages/Dashboard/Dictionaries/MeetingResults/MeetingResultsUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'meeting_result.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Результати зустрічей"
        }
    },

    //Agents
    {
        path: "/dictionaries/agents",
        name: "dictionaries.agents",
        component: loadView('components/Pages/Dashboard/Dictionaries/Agents/AgentsList'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'agent.viewAny'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Агенти"
        }
    },

    {
        path: "/dictionaries/agents/create",
        name: "dictionaries.agents.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/Agents/AgentsCreate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'agent.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Агенти"
        }
    },

    {
        path: "/dictionaries/agents/:id",
        name: "dictionaries.agents.update",
        component: loadView('components/Pages/Dashboard/Dictionaries/Agents/AgentsUpdate'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'agent.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Агенти"
        }
    },

    //Stages
    {
        path: "/dictionaries/stages",
        name: "dictionaries.stages",
        component: loadView('components/Pages/Dashboard/Dictionaries/Stages/List'),
        meta: {
            auth: {
                roles: ['SuperAdmin'].concat(permissions.methods.getAllForDirectoryStageAgreement()),
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Етапи угоди"
        }
    },

    {
        path: "/dictionaries/stage/create",
        name: "dictionaries.stage.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/Stages/Create'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'stage_agreement.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Етап угоди"
        }
    },

    {
        path: "/dictionaries/stage/:id",
        name: "dictionaries.stage.update",
        component: loadView('components/Pages/Dashboard/Dictionaries/Stages/Edit'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'stage_agreement.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Етап угоди"
        }
    },

    //IncomeSources
    {
        path: "/dictionaries/income-sources",
        name: "dictionaries.income_sources",
        component: loadView('components/Pages/Dashboard/Dictionaries/IncomeSources/List'),
        meta: {
            auth: {
                roles: ['SuperAdmin'].concat(permissions.methods.getAllForDirectoryIncomeSources()),
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Джерела надходження"
        }
    },

    {
        path: "/dictionaries/income-sources/create",
        name: "dictionaries.income_sources.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/IncomeSources/Create'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'income_source.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Джерело надходження"
        }
    },

    {
        path: "/dictionaries/income-sources/:id",
        name: "dictionaries.income_sources.update",
        component: loadView('components/Pages/Dashboard/Dictionaries/IncomeSources/Update'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'income_source.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Джерело надходження"
        }
    },

    //Cities
    {
        path: "/dictionaries/cities",
        name: "dictionaries.cities",
        component: loadView('components/Pages/Dashboard/Dictionaries/Cities/List'),
        meta: {
            auth: {
                roles: ['SuperAdmin'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Міста"
        }
    },

    {
        path: "/dictionaries/cities/create",
        name: "dictionaries.cities.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/Cities/Create'),
        meta: {
            auth: {
                roles: ['SuperAdmin'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Місто"
        }
    },

    {
        path: "/dictionaries/cities/:id",
        name: "dictionaries.cities.edit",
        component: loadView('components/Pages/Dashboard/Dictionaries/Cities/Edit'),
        meta: {
            auth: {
                roles: ['SuperAdmin'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Місто"
        }
    },

    //Districts
    {
        path: "/dictionaries/districts",
        name: "dictionaries.districts",
        component: loadView('components/Pages/Dashboard/Dictionaries/Districts/List'),
        meta: {
            auth: {
                roles: ['SuperAdmin'].concat(permissions.methods.getAllForDirectoryDistricts()),
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Райони"
        }
    },

    {
        path: "/dictionaries/districts/create",
        name: "dictionaries.districts.create",
        component: loadView('components/Pages/Dashboard/Dictionaries/Districts/Create'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'districts.create'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Район"
        }
    },

    {
        path: "/dictionaries/districts/:id",
        name: "dictionaries.districts.edit",
        component: loadView('components/Pages/Dashboard/Dictionaries/Districts/Edit'),
        meta: {
            auth: {
                roles: ['SuperAdmin', 'districts.update'],
                rolesKey: 'permissions'
            },
            layout: "DashboardLayout",
            title: "Район"
        }
    },

    //errors

    {
        path: "/403",
        name: "error-403",
        component: loadView('components/Pages/Errors/403'),
        meta: {
            layout: "ErrorLayout",
            title: "403"
        }
    },
    {
        path: "/404",
        name: "error-404-page",
        component: loadView('components/Pages/Errors/404'),
        meta: {
            layout: "ErrorLayout",
            title: "404"
        }
    },
    {
        path: "*",
        name: "error-404",
        component: loadView('components/Pages/Errors/404'),
        meta: {
            layout: "ErrorLayout",
            title: "404"
        }
    },
];

const router = new VueRouter({
    history: true,
    mode: "history",
    linkExactActiveClass: "link-active",
    routes
});

export default router;
